import ButtonLoader from 'utils/ButtonLoader';
// import { submitForm } from 'utils/Helpers';
import { ValidateRecaptcha } from 'utils/Validations'

const Forms = {
  el: {
    forms: document.querySelectorAll<HTMLFormElement>('.form'),
  },
  init() {
    if (this.el.forms.length > 0) {
      Array.prototype.forEach.call(this.el.forms, item => {
        const recaptchaError = (<HTMLElement>item.querySelector('.form__recaptcha-error'))
        const submitButton = item.querySelector('button[type="submit"]')

        item.addEventListener('submit', e => {
          ButtonLoader.start(submitButton)
          this.handleRecaptcha(e, recaptchaError, item)
        })
      });
    }
  },

  handleRecaptcha(event, element, form) {
    const submitButton = form.querySelector('button[type="submit"]')
    if (element) {
      if (!element.classList.contains('hide')) {
        element.classList.add('hide')
      }

      if (!ValidateRecaptcha()) {
        event.preventDefault()
        element.classList.remove('hide')
        ButtonLoader.reset(submitButton)
      }
    }
  },

  clearForm(form) {
    const inputs = form.querySelectorAll('input')
    const textareas = form.querySelectorAll('textarea')
    const selects = form.querySelectorAll('select')
    const checks = form.querySelectorAll('[type="checkbox"]')

    if (inputs) {
      this.clearInputType(inputs, 'text')
    }

    if (textareas) {
      this.clearInputType(textareas, 'text')
    }

    if (selects) {
      this.clearInputType(selects, 'select')
    }

    if (checks) {
      this.clearInputType(checks, 'check')
    }
  },

  clearInputType(items, type) {
    Array.prototype.forEach.call(items, item => {
      if (type === 'text') {
        item.value = ''
      }
      else if (type === 'select') {
        item.selectedIndex = 0
      }
      else if (type === 'check') {
        item.checked = false;
      }
    })
  },
}

export default Forms
